(function () {
  /**
   * @ngdoc module
   * @name binky.core.product.configurations
   * @description Module which contains product configurations related services
   */
  angular.module('binky.core.product.configurations', []);
})();
